import { render } from "./UserDropDown.vue?vue&type=template&id=0bfa747b"
import script from "./UserDropDown.vue?vue&type=script&lang=js"
export * from "./UserDropDown.vue?vue&type=script&lang=js"

import "./UserDropDown.vue?vue&type=style&index=0&id=0bfa747b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__